/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespHeroCarousel_viewer$ref: FragmentReference;
export type PdpRespHeroCarousel_viewer = {|
  +isRequestMoreImagesEnabled: ?boolean,
  +$refType: PdpRespHeroCarousel_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarousel_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isRequestMoreImagesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "REQUEST_MORE_IMAGES",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"REQUEST_MORE_IMAGES\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ab3cafa173d6bac3db4a623edec508eb';
module.exports = node;
